import { OknoRoleTeacherType } from '../store/accept'
import http from './http'

export async function getOknoTeacherRole() {
	const res = await http.post('/okno/teacher?stud_teacher=1')
	return res.data.Okno_role_teacher
}


export async function getNameHeadTeacher() {
	const res = await http.post('/okno/getNamePole?stud_teacher=1')
	return res.data.TypePole
} 

export async function getNameHeadStudent() {
	const res = await http.post('/okno/getNamePole?stud_teacher=0')
	return res.data.TypePole
}   
export async function setOknoTeacher(form: OknoRoleTeacherType) {
	const res = await http.post('/okno/customer')
	return res.data.result
}

export async function getOknoStudentRole() {
	const res = await http.post('/okno/studentlist?stud_teacher=0')
	return res.data.Okno_role
}

export async function getAcceprProperties(param: number) {
	const res = await http.get('/okno/accept/proporties?customer=' + param)
	return res.data.Okno_proporties_list
}
